import React from 'react';
import { ButtonContainer, ButtonText } from './Button.styles';
import { ButtonProps } from './types';
import { LoadingSpinner } from '../LoadingSpinner';

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  onClick,
  ...props
}) => {
  return (
    <ButtonContainer
      $variant={variant}
      $size={size}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      <ButtonText>
        {loading && <LoadingSpinner size="small" color="#ffffff" />}
        {loading ? 'Loading...' : children}
      </ButtonText>
    </ButtonContainer>
  );
};
